export default {
    limitOrders: [],
    voucherLimits: [],
};
